import axios from 'axios'
import qs from 'qs'
import {
  Message,
  MessageBox,
  Loading
} from 'element-ui'
import configUrl from './config'

let loading = null
export const ajax = axios.create({
  baseUrl: configUrl.baseUrl,
  timeout: 120000,
  ourConfig: 0
})

// // 添加请求拦截器
ajax.interceptors.request.use(config => {
  config.headers['Token_'] = sessionStorage.token || ''
  config.headers['userIp'] = sessionStorage.userIp || ''
  loading = Loading.service({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0)'
  });
  //   loading.close()
  // 在发送请求之前做些什么
  return config
}, error => {
  // 对请求错误做些什么
  console.log(error)
  Message({
    showClose: true,
    message: '网络服务错误，请稍后尝试',
    type: 'error',
    duration: 5 * 1000,
    showClose: true
  })
  return Promise.reject(error)
})
// // 添加响应拦截器
ajax.interceptors.response.use(response => {
   // 对响应数据做点什么
    loading.close();
    const res = response.data
    if(res.code === '-106'){
        Message({
            message: res.message,
            type: 'error',
            duration: 5 * 1000,
            showClose: true
          })
          return Promise.reject(res.message)
    }
    if(res.code === '-101'){
        Message({
            message: res.message,
            type: 'error',
            duration: 5 * 1000,
            showClose: true
          })
          return Promise.reject(res.message)
    }
    return res
}, error => {
  loading.close();
  return Promise.reject(error)
})

export const axiosAjax = (method, url, params, config) => {
  let data, info
  if (method == 'post') {
    data = 'data'
    info = qs.stringify(params)
  } else {
    data = 'params'
    info = params
  }
  return ajax({
    method: method,
    baseURL: configUrl.baseUrl,
    url: url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    [data]: info || {},
    ourConfig: config
  })
}

export const axiosNewAjax = (method, url, params, config) => {
  let data
  if (method == 'post') {
    data = 'data'
  } else {
    data = 'params'
  }
  return ajax({
    method: method,
    baseURL: configUrl.baseUrl,
    url: url,
    headers: {
      'Content-Type': 'application/json'
    },
    [data]: params || {},
    ourConfig: config
  })
}




// WEBPACK FOOTER //
// ./src/utils/ajax.js